import { SolutionsEnvironmentView } from "~landing/views/solutions/environment";
import { NextPage } from "next";
import { MarketingSeo } from "~landing/seo/marketing-seo";
import { useEffect } from "react";
import { sendLandingPageViewEvent } from "~tag-manager/send-event";

const SolutionsEnvironmentPage: NextPage = () => {
	useEffect(() => {
		sendLandingPageViewEvent({ icp: "environment" });
	}, []);

	return (
		<>
			<MarketingSeo
				path="/solutions/environment"
				title="Online GIS for environmental teams"
				description="Create and securely share maps your way. The accessible and user-friendly alternative to Esri for smart spenders."
			/>
			<SolutionsEnvironmentView />
		</>
	);
};

export default SolutionsEnvironmentPage;
